import { render, staticRenderFns } from "./setRate.vue?vue&type=template&id=6b8681fe&scoped=true"
import script from "./setRate.vue?vue&type=script&lang=js"
export * from "./setRate.vue?vue&type=script&lang=js"
import style0 from "./setRate.vue?vue&type=style&index=0&id=6b8681fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8681fe",
  null
  
)

export default component.exports